/* eslint-disable max-len */
import React, { HTMLProps } from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { CreditCardFilled } from '@ant-design/icons';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Text } from '~/components/Typo/Typo';
import { FontWeight, TextVariants } from '~/theme/constants';
import TextField from '~/components/fields/TextField/TextField';
import Button from '~/components/Button/Button';

import './PinForm.scss';

export interface PinFormProps extends HTMLProps<HTMLFormElement> {
  handleSubmit: (values: any) => void;
  selectedItem?: number;
  loading?: boolean;
}

const PinForm: React.FC<PinFormProps> = ({ handleSubmit, loading }) => {
  const { t } = useTranslation();

  const validate = Yup.object({
    pin: Yup.string().required(t('pinForm:pinCodeRequired')),
  });

  return (
    <div className="pin-payment-form">
      <div className={cn('caption-wrapper')}>
        <Text className="caption" size="s" weight={FontWeight.MEDIUM} variant={TextVariants.PRIMARY}>
          {t('pinForm:enterPinCode')}
        </Text>
      </div>
      <div className="form-wrapper">
        <Formik
          onSubmit={values => {
            handleSubmit(values);
          }}
          initialValues={{
            pin: '',
          }}
          enableReinitialize
          validationSchema={validate}
        >
          {() => (
            <Form>
              <TextField
                name="pin"
                type="number"
                className="text-field-card-form"
                label={t('pinForm:pinCode')}
                placeholder={t('pinForm:pinCode')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              />
              <div className="submit-button-wrapper">
                <Button
                  title={t('pinForm:send')}
                  size="block"
                  rounded
                  type="submit"
                  disabled={loading}
                  loading={loading}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PinForm;
